import { Field, useFormikContext } from 'formik';
import { Link } from 'react-router-dom';
import Address from 'src/components/util/Address';
import AgreedToTermsCheckbox from 'src/components/util/AgreedToTermsCheckbox';
import MuiValidTextField from 'src/components/util/MuiValidTextField';
import Section from 'src/components/util/Section';
import Subheader from 'src/components/util/Subheader';
import { OWNER_INFO } from 'src/data/OwnerInfo/constant';
import formatPhoneNumber from 'src/util/formatPhoneNumber';

export default function OwnerInfo() {
  const { setFieldValue, errors } = useFormikContext();

  const handleChange = (field) => (e) => {
    setFieldValue(field, e.target.value);
  };
  const handleChangePhone = (field) => (e) => {
    setFieldValue(field, formatPhoneNumber(e.target.value));
  };

  return (
    <Section title="Owner Information">
      <Subheader>Owner Information</Subheader>
      {OWNER_INFO.ownerInfoFields.map(({ label, name, type }, index) => (
        <Field
          InputLabelProps={{ shrink: true }}
          component={MuiValidTextField}
          label={label}
          key={index}
          name={name}
          onChange={type !== 'tel' ? handleChange(name) : handleChangePhone(name)}
          type={type}
        />
      ))}

      <Subheader>Mailing Address</Subheader>
      <Address fieldNames={OWNER_INFO.mailAddressFields} />

      <Field
        InputLabelProps={{ shrink: true }}
        component={MuiValidTextField}
        label={OWNER_INFO.serialNumberField.label}
        name={OWNER_INFO.serialNumberField.name}
        onChange={handleChange(OWNER_INFO.serialNumberField.name)}
        type={OWNER_INFO.serialNumberField.type}
      />

      <Field
        InputLabelProps={{ shrink: true }}
        component={MuiValidTextField}
        label={OWNER_INFO.additionalSerialNumbersField.label}
        multiline={OWNER_INFO.additionalSerialNumbersField.multiline}
        name={OWNER_INFO.additionalSerialNumbersField.name}
        onChange={handleChange(OWNER_INFO.additionalSerialNumbersField.name)}
        placeholder={OWNER_INFO.additionalSerialNumbersField.placeholder}
        type={OWNER_INFO.additionalSerialNumbersField.type}
        rows={OWNER_INFO.additionalSerialNumbersField.rows}
        variant={OWNER_INFO.additionalSerialNumbersField.variant}
      />

      <Field
        InputLabelProps={{ shrink: true }}
        component={MuiValidTextField}
        label={OWNER_INFO.statementField.label}
        multiline={OWNER_INFO.statementField.multiline}
        name={OWNER_INFO.statementField.name}
        onChange={handleChange(OWNER_INFO.statementField.name)}
        placeholder={OWNER_INFO.statementField.placeholder}
        type={OWNER_INFO.statementField.type}
        rows={OWNER_INFO.statementField.rows}
        variant={OWNER_INFO.statementField.variant}
      />

      <p>
        Note: The Treasurer&apos;s Office is authorized to review the penalty assessed on a tax
        amount up to $5,000.00.
      </p>
      <p>
        All other requests must be processed under{' '}
        <Link
          className="font-medium text-blue-600 hover:underline dark:text-blue-500"
          to={`/processing-requests`}
          rel="noreferrer"
          target="_blank"
        >
          Section 21-8-2(A)
        </Link>{' '}
        of the Utah County Code.
      </p>
      <Subheader>By submitting this document, I declare the following: </Subheader>

      <AgreedToTermsCheckbox
        label="I have verified that the information entered above is correct. I understand and acknowledge to comply with all Utah County and Utah State requirements to request an appeal for my real property."
        name="owner.agreedToTerms"
        errorMessage={errors?.owner?.agreedToTerms}
      />
    </Section>
  );
}
